import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { Button } from "../Button";
import { RegistroComprometido } from "../RegistroComprometido";
import { FieldText } from "../../components/FieldText";

export const Modal = ({
  type,
  title,
  message,
  labelConfirm,
  values,
  setValues,
  confirm,
  cancel,
  lists,
  area,
  metadataTable,
  setMetadataTable,
}) => {
  const body = () => {
    switch (type) {
      case "cargarComprometido":
        return (
          <>
            <h3 className="centered">{message}</h3>
            <RegistroComprometido
              metadataTable={metadataTable}
              setMetadataTable={setMetadataTable}
              edit={true}
              create={true}
              lists={lists}
              setComprometido={setValues}
              area={area}
            />
          </>
        );

      case "editarComprometido":
        return (
          <>
            <h3 className="centered">{message}</h3>
            <RegistroComprometido
              metadataTable={metadataTable}
              setMetadataTable={setMetadataTable}
              edit={true}
              comprometido={values}
              setComprometido={setValues}
              lists={lists}
              area={area}
            />
          </>
        );

      case "visualizarComprometido":
        return (
          <>
            <h3 className="centered">{message}</h3>
            <RegistroComprometido
              metadataTable={metadataTable}
              comprometido={values}
              lists={lists}
              area={area}
            />
          </>
        );

      case "eliminarComprometido":
        return <p className="centered">{message}</p>;
      
      case "editarBuzonCorreo":
        return (
          <>
            <h3 className="centered">{message}</h3>
            <FieldText
              id='buzonCorreo'
              value={values}
              handleChange={setValues}
            />
          </>
        );

      default:
        return <></>;
    }
  };


const buttons = () => (
  <S.FixedActionContainer>
    {type === "visualizarComprometido" ? (
      <Button label={labelConfirm} onClick={cancel} type="cancel" />
    ) : (
      <>
        <Button label="Cancelar" onClick={cancel} type="cancel" />
        <Button label={labelConfirm} onClick={confirm} />
      </>
    )}
  </S.FixedActionContainer>
);

  return (
    <S.Wrapper onClick={cancel}>
      <S.Content onClick={(event) => event.stopPropagation()}>
        <S.Header>
          <p>{title}</p>
        </S.Header>
        <S.Body>
          {body()}
          <S.Buttons>{buttons()}</S.Buttons>
        </S.Body>
      </S.Content>
    </S.Wrapper>
  );
};

Modal.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  labelConfirm: PropTypes.string,
  values: PropTypes.object,
  summary: PropTypes.object,
  confirm: PropTypes.func,
  cancel: PropTypes.func,
  metadataTable: PropTypes.array,
  setMetadataTable: PropTypes.func,
};
